<app-pageheader [Parent]="this">
</app-pageheader>
  
<app-datalistview [Columns]="Columns" [ShowMap]="true" ApiUrl="infrastructure/signconfigurations/searches"
[AllowEdit]="true" EditUrl="/hardware/devices/signs/:id" [StructureViewerLayers]="StructureViewerLayers" StructureViewerForType="SignConfiguration">
    <app-filter-set>
        <div app-search-filter></div>
        <div app-search-button></div>
    </app-filter-set>
</app-datalistview>